import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=6f490fcd"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"
import style0 from "./Medical.vue?vue&type=style&index=0&id=6f490fcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports